/* eslint-disable no-use-before-define */

import React from 'react'
import YieldGrids from './yield-grids'
import ScatterGraph from './scatter-graph'
// import MarketNews from './market-news'
import MarketSnapshot from './market-snapshot'
import QuickScreener from './quick-screener'
import Resources from './resources'
import SectorActivity from './sector-activity'
import {trackPage} from '../twd'

export default () => {
    trackPage('corporates')

    return (
    <React.Fragment>

    <div className="container" style={{padding:0}}>
    <div className="row">
    <div className="col-md-12">
        <YieldGrids />
    </div>
    </div>
    </div>

    <div style={{backgroundColor:"#f6f6f6"}}>
    <div className="container">
    <div className="row vertical-offset-sm">

        <div className="col-md-8 col-xs-12">
        <ScatterGraph />
        {/* <MarketNews /> */}
        <MarketSnapshot />
        </div>

        <div className="col-md-4 col-xs-12">
        <QuickScreener />
        <Resources />
        <SectorActivity />
        </div>
    </div>
    </div>
    </div>
    </React.Fragment>)
}



// WEBPACK FOOTER //
// ./src/corporates/corporates.js